






import Vue from "vue"

export default Vue.extend({
  props: ['src'],

  data() {
    return {
      loading: true
    }
  },

  methods: {
    onLoaded() {
      this.loading = false
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GrafanaGraph.vue